module.exports = __webpack_public_path__ + "static/media/arrow_black.ef17f4e2.svg";